import React from 'react';
import T from 'i18n-react';
import { hydrate, render } from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'
import BasicComponent from './components/basic';
import App from './app';
import NotFound from './components/layout/not-found';
import './static/css/style.css';

let appProps = {
  T: T,
  debugMode: process.env.REACT_APP_DEBUG === 'true',
  apiURL: process.env.REACT_APP_API_URL,
  gaCode: process.env.REACT_APP_GA_CODE || 'UA-XXXXXXXX-Y',
  mailchimpUrl: process.env.REACT_APP_MAILCHIMP_URL,
  responseTimeout: process.env.REACT_APP_RESPONSE_TIMEOUT,
  langUrl: process.env.REACT_APP_CLIENT_URL,
  listLocale: ['ja', 'en'],
  defaultLocale: 'ja',
  sessionStorage: window.sessionStorage || {},
  hash : window.location.hash.substr(1)
};

// detect app locale
try {
  const filterLocale = (str) => (str && ~appProps.listLocale.indexOf(str) && str)
  appProps.locale = filterLocale(appProps.hash)
                    || filterLocale(appProps.sessionStorage && appProps.sessionStorage.currentLocale)
                    || (!(/bot|googlebot|crawler|spider|robot|crawling/i.test(window.navigator.userAgent || '')) && filterLocale((window.navigator.language || '').substr(0, 2)))
                    || appProps.defaultLocale
} catch (e) {}

// reset hash
window.location.hash = ''

const renderApp = (props) => {return () => { return <App {...props} />}}

class RoutedApp extends BasicComponent {
  constructor(props) {
    super(props);
    this.setAppLocale = this.setAppLocale.bind(this);
    this.setAppLocale(this.props.locale)
  }

  render() {
    let props = Object.assign({
      setAppLocale: this.setAppLocale
    }, this.props);
    return (
      <Router>
        <Switch>
          <Route exact path="/" render={renderApp(props)} />
          <Route exact path="/200.html" render={renderApp(props)} />
          <Route exact path="/index.html" render={renderApp(props)} />
          <Route path="*" render={() => { return <NotFound {...props}/> }} />
        </Switch>
      </Router>
    );
  }

  setAppLocale(locale) {
    let {T, sessionStorage, listLocale, defaultLocale} = this.props;
    locale = (~listLocale.indexOf(locale)) ? locale : defaultLocale
    sessionStorage.currentLocale = locale
    T.setTexts(
      require("./static/translations/" + locale),
      {notFound: key => `${key}`}
    )
    return locale
  }

}

const rootElement = document.getElementById('rabbit-lp-app');
if (!document.querySelector('#rabbit-lp-app img.loading')) {
  hydrate(<RoutedApp {...appProps} />, rootElement);
} else {
  render(<RoutedApp {...appProps} />, rootElement);
}



// WEBPACK FOOTER //
// ./src/index.js